import React, { useState } from 'react';
import FormAddEvent from '../FormAddEvent';
import FormAddEventHeat from '../FormAddEventHeat';
import FormAddEventRemind from '../FormAddEventRemind';
import FormAddEventPregnant from '../FormAddEventPregnant';
import FormAddEventInsemination from '../FormAddEventInsemination';
import FormAddEventAbortion from '../FormAddEventAbortion';
import FormConfirm from '../FormConfirm';

const AddEvent = ({ cowid, cowno, title, events, buttons, refetchCow, handleToggleIsOpenModal }) => {
    const [event, setEvent] = useState(null);
    const [isSent, setIsSent] = useState(false);
    const [confirm, setConfirm] = useState({});
    const handleClickEvent = event => () => {
        setEvent(event);
    };
    const handleClickCancel = () => {
        setEvent(null);
    }
    const handleClickSave = confirm => {
        setIsSent(true);
        setConfirm(confirm);
    }
    const handleClickConfirm = () => {
        handleToggleIsOpenModal();
        refetchCow({ loader: false});
    }
    return (
        <>
            {
                !isSent && event === null &&
                <FormAddEvent
                    title={title}
                    events={events}
                    buttons={buttons}
                    onClickEvent={handleClickEvent}
                    onClickCancel={handleToggleIsOpenModal}
                />
            }
            {
                !isSent && event && event.id === "heat" &&
                <FormAddEventHeat
                    cowid={cowid}
                    cowno={cowno}
                    endpoint={event.endpoint}
                    onClickCancel={handleClickCancel}
                    onClickSave={handleClickSave}
                />
            }
            {
                !isSent && event && event.id === 2 &&
                <FormAddEventRemind
                    cowid={cowid}
                    cowno={cowno}
                    endpoint={event.endpoint}
                    onClickCancel={handleClickCancel}
                    onClickSave={handleClickSave}
                />
            }
            {
                !isSent && event && event.id === "pregnant" &&
                <FormAddEventPregnant
                    cowid={cowid}
                    cowno={cowno}
                    endpoint={event.endpoint}
                    onClickCancel={handleClickCancel}
                    onClickSave={handleClickSave}
                />
            }
            {
                !isSent && event && event.id === "insemination" &&
                <FormAddEventInsemination
                    cowid={cowid}
                    cowno={cowno}
                    endpoint={event.endpoint}
                    onClickCancel={handleClickCancel}
                    onClickSave={handleClickSave}
                />
            }
            {
                !isSent && event && event.id === "abortion" &&
                <FormAddEventAbortion
                    cowid={cowid}
                    cowno={cowno}
                    endpoint={event.endpoint}
                    onClickCancel={handleClickCancel}
                    onClickSave={handleClickSave}
                />
            }
            {
                isSent &&
                <FormConfirm
                    onClick={handleClickConfirm}
                    confirm={confirm}
                />
            }
        </>
    );
};

export default AddEvent;